(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("element-form-verify"), require("vue"), require("time-range-picker"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define("plain-kit", ["element-form-verify", "vue", "time-range-picker", "axios"], factory);
	else if(typeof exports === 'object')
		exports["plain-kit"] = factory(require("element-form-verify"), require("vue"), require("time-range-picker"), require("axios"));
	else
		root["plain-kit"] = factory(root["element-form-verify"], root["vue"], root["time-range-picker"], root["axios"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__6dc2__, __WEBPACK_EXTERNAL_MODULE__8bbf__, __WEBPACK_EXTERNAL_MODULE_b11f__, __WEBPACK_EXTERNAL_MODULE_cebe__) {
return 